export const TAB_OVERVIEW = 'overview';
export const TAB_DOCUMENTS = 'documents';
export const TAB_PASSPORTS = 'passports';

export const tabOptions = [
  { value: TAB_OVERVIEW, label: 'Overview' },
  { value: TAB_DOCUMENTS, label: 'Documents' },
  { value: TAB_PASSPORTS, label: 'Passports' },
];
